import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-three-two-one',
  templateUrl: './c4-four-three-two-one.component.html',
  styleUrls: ['./c4-four-three-two-one.component.scss']
})
export class C4FourThreeTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
